/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalFilterExclusionInput } from './GlobalFilterExclusionInput';
import {
    GlobalFilterExclusionInputFromJSON,
    GlobalFilterExclusionInputFromJSONTyped,
    GlobalFilterExclusionInputToJSON,
    GlobalFilterExclusionInputToJSONTyped,
} from './GlobalFilterExclusionInput';
import type { LeagueStatus } from './LeagueStatus';
import {
    LeagueStatusFromJSON,
    LeagueStatusFromJSONTyped,
    LeagueStatusToJSON,
    LeagueStatusToJSONTyped,
} from './LeagueStatus';
import type { RoundRobinType } from './RoundRobinType';
import {
    RoundRobinTypeFromJSON,
    RoundRobinTypeFromJSONTyped,
    RoundRobinTypeToJSON,
    RoundRobinTypeToJSONTyped,
} from './RoundRobinType';
import type { MatchScoringMode } from './MatchScoringMode';
import {
    MatchScoringModeFromJSON,
    MatchScoringModeFromJSONTyped,
    MatchScoringModeToJSON,
    MatchScoringModeToJSONTyped,
} from './MatchScoringMode';
import type { MatchFormat } from './MatchFormat';
import {
    MatchFormatFromJSON,
    MatchFormatFromJSONTyped,
    MatchFormatToJSON,
    MatchFormatToJSONTyped,
} from './MatchFormat';
import type { TiebreakerMethod } from './TiebreakerMethod';
import {
    TiebreakerMethodFromJSON,
    TiebreakerMethodFromJSONTyped,
    TiebreakerMethodToJSON,
    TiebreakerMethodToJSONTyped,
} from './TiebreakerMethod';
import type { UpdateLeagueBodyPointsConfig } from './UpdateLeagueBodyPointsConfig';
import {
    UpdateLeagueBodyPointsConfigFromJSON,
    UpdateLeagueBodyPointsConfigFromJSONTyped,
    UpdateLeagueBodyPointsConfigToJSON,
    UpdateLeagueBodyPointsConfigToJSONTyped,
} from './UpdateLeagueBodyPointsConfig';

/**
 * 
 * @export
 * @interface UpdateLeagueBody
 */
export interface UpdateLeagueBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateLeagueBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeagueBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeagueBody
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeagueBody
     */
    matchModeId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeagueBody
     */
    ruleSetId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeagueBody
     */
    sponsorId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeagueBody
     */
    seasonName?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeagueBody
     */
    seasonNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeagueBody
     */
    seasonStartDate?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeagueBody
     */
    seasonEndDate?: number;
    /**
     * 
     * @type {RoundRobinType}
     * @memberof UpdateLeagueBody
     */
    roundRobinType?: RoundRobinType;
    /**
     * 
     * @type {MatchScoringMode}
     * @memberof UpdateLeagueBody
     */
    scoringMode?: MatchScoringMode;
    /**
     * 
     * @type {MatchFormat}
     * @memberof UpdateLeagueBody
     */
    matchFormat?: MatchFormat;
    /**
     * 
     * @type {UpdateLeagueBodyPointsConfig}
     * @memberof UpdateLeagueBody
     */
    pointsConfig?: UpdateLeagueBodyPointsConfig;
    /**
     * 
     * @type {Array<TiebreakerMethod>}
     * @memberof UpdateLeagueBody
     */
    tiebreakerMethods?: Array<TiebreakerMethod>;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeagueBody
     */
    teamSize?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeagueBody
     */
    maxTeams?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeagueBody
     */
    minTeams?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLeagueBody
     */
    requiresApproval?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeagueBody
     */
    registrationDeadline?: number;
    /**
     * 
     * @type {LeagueStatus}
     * @memberof UpdateLeagueBody
     */
    status?: LeagueStatus;
    /**
     * ScoringTemplate ID for EVENT_PIPELINE scoring
     * @type {string}
     * @memberof UpdateLeagueBody
     */
    scoringTemplateId?: string;
    /**
     * Cheat-filtering match-bracketing gate — requires active Match Start / Round Start in Redis to score
     * @type {boolean}
     * @memberof UpdateLeagueBody
     */
    requireActiveMatch?: boolean;
    /**
     * Inclusion-framework WU 1.10.7 — IDs of EventPipelineFilter documents to apply to this league's events. Passing an empty array clears all filter assignments.
     * @type {Array<string>}
     * @memberof UpdateLeagueBody
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass exclusions of GLOBAL filters for this league (PRODUCT_PLAN D2(b)). excludedBy and excludedAt are stamped server-side and ignored if sent.
     * @type {Array<GlobalFilterExclusionInput>}
     * @memberof UpdateLeagueBody
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusionInput>;
    /**
     * Rule 4 opt-out. When true this league still scores events whose match context is missing. Default false — a league that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof UpdateLeagueBody
     */
    failOpenOnMissingContext?: boolean;
}



/**
 * Check if a given object implements the UpdateLeagueBody interface.
 */
export function instanceOfUpdateLeagueBody(value: object): value is UpdateLeagueBody {
    return true;
}

export function UpdateLeagueBodyFromJSON(json: any): UpdateLeagueBody {
    return UpdateLeagueBodyFromJSONTyped(json, false);
}

export function UpdateLeagueBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeagueBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'matchModeId': json['matchModeId'] == null ? undefined : json['matchModeId'],
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'sponsorId': json['sponsorId'] == null ? undefined : json['sponsorId'],
        'seasonName': json['seasonName'] == null ? undefined : json['seasonName'],
        'seasonNumber': json['seasonNumber'] == null ? undefined : json['seasonNumber'],
        'seasonStartDate': json['seasonStartDate'] == null ? undefined : json['seasonStartDate'],
        'seasonEndDate': json['seasonEndDate'] == null ? undefined : json['seasonEndDate'],
        'roundRobinType': json['roundRobinType'] == null ? undefined : RoundRobinTypeFromJSON(json['roundRobinType']),
        'scoringMode': json['scoringMode'] == null ? undefined : MatchScoringModeFromJSON(json['scoringMode']),
        'matchFormat': json['matchFormat'] == null ? undefined : MatchFormatFromJSON(json['matchFormat']),
        'pointsConfig': json['pointsConfig'] == null ? undefined : UpdateLeagueBodyPointsConfigFromJSON(json['pointsConfig']),
        'tiebreakerMethods': json['tiebreakerMethods'] == null ? undefined : ((json['tiebreakerMethods'] as Array<any>).map(TiebreakerMethodFromJSON)),
        'teamSize': json['teamSize'] == null ? undefined : json['teamSize'],
        'maxTeams': json['maxTeams'] == null ? undefined : json['maxTeams'],
        'minTeams': json['minTeams'] == null ? undefined : json['minTeams'],
        'requiresApproval': json['requiresApproval'] == null ? undefined : json['requiresApproval'],
        'registrationDeadline': json['registrationDeadline'] == null ? undefined : json['registrationDeadline'],
        'status': json['status'] == null ? undefined : LeagueStatusFromJSON(json['status']),
        'scoringTemplateId': json['scoringTemplateId'] == null ? undefined : json['scoringTemplateId'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionInputFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
    };
}

export function UpdateLeagueBodyToJSON(json: any): UpdateLeagueBody {
    return UpdateLeagueBodyToJSONTyped(json, false);
}

export function UpdateLeagueBodyToJSONTyped(value?: UpdateLeagueBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'gameId': value['gameId'],
        'matchModeId': value['matchModeId'],
        'ruleSetId': value['ruleSetId'],
        'sponsorId': value['sponsorId'],
        'seasonName': value['seasonName'],
        'seasonNumber': value['seasonNumber'],
        'seasonStartDate': value['seasonStartDate'],
        'seasonEndDate': value['seasonEndDate'],
        'roundRobinType': RoundRobinTypeToJSON(value['roundRobinType']),
        'scoringMode': MatchScoringModeToJSON(value['scoringMode']),
        'matchFormat': MatchFormatToJSON(value['matchFormat']),
        'pointsConfig': UpdateLeagueBodyPointsConfigToJSON(value['pointsConfig']),
        'tiebreakerMethods': value['tiebreakerMethods'] == null ? undefined : ((value['tiebreakerMethods'] as Array<any>).map(TiebreakerMethodToJSON)),
        'teamSize': value['teamSize'],
        'maxTeams': value['maxTeams'],
        'minTeams': value['minTeams'],
        'requiresApproval': value['requiresApproval'],
        'registrationDeadline': value['registrationDeadline'],
        'status': LeagueStatusToJSON(value['status']),
        'scoringTemplateId': value['scoringTemplateId'],
        'requireActiveMatch': value['requireActiveMatch'],
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionInputToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
    };
}

